import React from "react";

const InputFile = ({ labelName, name, value, onChange }) => {
  return (
    <label>
      <span className="block text-left font-nunito text-xs font-thin text-black/70">
        {labelName}
      </span>
      <input
        type="file"
        name={name}
        value={value}
        onChange={(e) => onChange(e)}
        className="animate mt-1 block
      w-full text-sm file:mr-4
      file:cursor-pointer file:rounded-full file:border-0
      file:bg-smoot/70 file:py-2 file:px-4
      file:text-xs file:font-thin file:text-secondary hover:file:bg-smoot hover:file:font-normal hover:file:text-primary
    "
      />
    </label>
  );
};

export default InputFile;
